export enum TrimDetail {
  AngledHeaderEnds = 'angled-header-ends',
  AngledOpening = 'angled-opening',
  // FIXME: rename constant so that it reflects #4268 - being able to add to rollup doors as well.
  GarageDoorAngledOpeningTrim = 'garage-door-angled-opening-trim',
  GarageDoorAngledOpeningTrimPineviewStyle = 'garage-door-angled-opening-trim-pineview-style',
  HorizontalStaticTrimExtendToMeetWithOtherWalls = 'horizontal-static-trim-extend-to-meet-with-other-walls', // wainscot
  ProShedTrim = 'pro-shed-trim',
  TopSeventyDegreesAngledHeaderWithHalfInchExtension = 'top-seventy-degrees-angled-header-ends-half-inch-past',
  SeventyDegreesAngledHeaderWithHalfInchExtension = 'seventy-degrees-angled-header-ends-half-inch-past',
  ExtendedHeaderTrim = 'extended-header-trim',
  ExtendedHeaderAndBottomTrim = 'extended-header-and-bottom-trim',
  ExtendedWithPeakTrim = 'top-trim-raised-middle-ends-past',
  Standard = 'standard',
  StoltzfusArchedCarriageWindow = 'stoltzfus-arched-carriage-window',
  VinylDoorTrimWithLip = 'vinyl-door-trim-with-lip',
}
